import { text_to_slug } from "../../util/methods"

// sluggify shop name
$(document).on("keyup", "#vendor_application_company_name", function () {
  if (window.location.pathname === "/application/new") {
    $("#vendor_application_shop_slug")
      .val(text_to_slug($(this).val()))
      .trigger("input")
  }
})
